<style lang="less" scoped>	
    .ws-content {
        margin: 98px 0px 0px 240px;
    	.main-content {
    		padding: 10px 10px 30px 10px;
    	}
        .page-heading {
            height: 20px;
            line-height: 20px;
            margin-bottom: 10px;
        }
        .page-content {
			padding: 5px;
            background: #fff;
            border-radius: 1px;
            box-shadow: 1px 0 10px 1px rgba(0,0,0,.1);
        }
        .left-side-arrow {
			display: none;
            position: fixed;
            // display: none;
            top: 98px;
            left: 239px;
            z-index: 10;
            width: 28px;
            height: 42px;
            text-align: center;
            line-height: 35px;
            color: #fff;
            background-color: #404040;
            border-radius: 0em 2em 2em 0em;
            cursor: pointer;
            filter:alpha(opacity=50);  
            -moz-opacity:0.5;  
            -khtml-opacity: 0.5;  
            opacity: 0.5;  

            i {
                font-size: 22px;
            }
        }
		.right-side-arrow-top {
			position: fixed;
			// display: none;
			bottom: 98px;
			right: 1px;
			z-index: 10;
			width: 28px;
			height: 30px;
			text-align: center;
			line-height: 35px;
			color: #fff;
			background-color: #404040;
			border-radius: 2em 2em 0em 0em;
			cursor: pointer;
			filter:alpha(opacity=50);  
			-moz-opacity:0.5;  
			-khtml-opacity: 0.5;  
			opacity: 0.5;  
			
			i {
			    font-size: 25px;
				padding-top: 2px;
			}
		}
		.right-side-arrow-bottom {
			position: fixed;
			// display: none;
			bottom: 87px;
			right: 1px;
			z-index: 10;
			width: 28px;
			height: 30px;
			text-align: center;
			line-height: 35px;
			color: #fff;
			background-color: #404040;
			border-radius: 0em 0em 2em 2em;
			cursor: pointer;
			filter:alpha(opacity=50);  
			-moz-opacity:0.5;  
			-khtml-opacity: 0.5;  
			opacity: 0.5;  
			
			i {
			    font-size: 25px;
				padding-top: 2px;
			}
		}
        .scrollbar-warpper {
            max-height: 450px;
        }
    }

    .left-side-collapsed {
        .ws-content {
            margin: 98px 0px 0px 0px;

            .left-side-arrow {
                left: 1px;
            }
        }
    }
</style>
<template>
    <div class="ws-content">
        <nav-menu></nav-menu>
		<!--显示隐藏-->
        <div class="left-side-arrow" @click="togglebtn($event)">
            <el-tooltip class="item" effect="dark" :content="leftSideOpen ? '显示左侧菜单' : '隐藏左侧菜单'" placement="left">
                <i class="ws-iconfont" :class="leftSideOpen ? 'wsicon-menuunfold' : 'wsicon-menufold'"></i>
            </el-tooltip>
        </div>   
		<div class="main-content">
			<!-- page heading start-->
			<div class="page-heading main-heading" hidden="hidden">
				<el-breadcrumb separator="/">
				  <el-breadcrumb-item v-for="(item, index) in breadCrumbs">{{item.name}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<!-- page heading end-->
			<div class="page-content">
				<!-- 路由外链 -->
				<keep-alive>
					<router-view v-if="!$route.meta.keepAlive"></router-view>
				</keep-alive>
				<router-view v-if="$route.meta.keepAlive"></router-view>
			</div>
		</div>
		<div class="right-side-arrow-top" @click="toggleTop($event)">
			<el-tooltip class="item" effect="dark" content="回到顶部" placement="right">
				<i class="el-icon-caret-top"></i>
			</el-tooltip>
		</div>
		<div class="right-side-arrow-bottom" @click="toggleBottom($event)">
			<el-tooltip class="item" effect="dark" content="回到底部" placement="right">
				<i class="el-icon-caret-bottom"></i>
			</el-tooltip>
		</div>
    </div>
</template>
<script>
    import navMenu from './navmenu.vue';
    import $ from 'jquery';
    import m from 'malihu-custom-scrollbar-plugin';
    import mw from 'jquery-mousewheel';
    import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css';
    export default {
        components: {
            navMenu
        },
        data() {
            return {
            }
        },
        computed: {
            leftSideOpen() { //左边关闭状态计算属性
                const isOpen =  this.$store.getters.framework_leftSideOpenStatus;
                return isOpen;
            },
            currentView() {
                const view = this.$store.getters.frameworktabs_currentView;
                return view;
            },
            breadCrumbs() {
                let crumbs_ = this.$store.getters.framework_crumbs;
                return crumbs_;
            }
        },
        mounted() {
            this.init();
        },
        methods : {
            //切换按钮      
            togglebtn: function(e) {
                this.$store.dispatch('frameworkToggleLeftSideStatus');
            },
            init() {
                var obj = this;
                this.$nextTick(function(){
                    this.bindScroll();
                    $(window).resize(function() {
                        obj.bindScroll();
                    });
                });
            },
            bindScroll() {
                let height = $(window).height();
                $('.ws-content').css('height', height - 56);   
                $('.ws-content').mCustomScrollbar({
                     theme:"minimal-dark",
                     scrollInertia : 500
                });               
            },
			/**
			 * 回到顶部及底部的切换
			 */
			toggleTop(e) {
				$('.ws-content').mCustomScrollbar('scrollTo', 'top');
			},
			/**
			 * 回到顶部
			 */
			toggleBottom(e) {
				$('.ws-content').mCustomScrollbar('scrollTo', 'bottom');
			}
        }           
    }
</script>


// WEBPACK FOOTER //
// content.vue?f537fae8